<template>
  <v-row>
    <v-col>
      <v-row dense>
        <v-col class="text-h5 gray--text"> Alergias </v-col>
      </v-row>

      <v-row dense v-if="showForm">
        <v-col>
          <v-combobox
            v-model="allergySubstance"
            outlined
            dense
            :hide-details="allergySubstanceError === ''"
            :error-messages="allergySubstanceError"
            label="Substâncias"
            :items="orderedAllergies"
            item-text="name"
            background-color="white"
          />
        </v-col>

        <v-col>
          <v-combobox
            v-model="allergyType"
            outlined
            dense
            hide-details
            label="Tipo de alergia"
            :items="allergyTypes"
            item-text="name"
            background-color="white"
          />
        </v-col>
      </v-row>

      <v-row v-if="showForm">
        <v-col>
          <v-textarea
            v-model="description"
            v-uppercase
            outlined
            dense
            hide-details
            label="Descrição"
            background-color="white"
          />
        </v-col>
      </v-row>

      <v-row dense v-if="showForm">
        <v-col>
          <v-btn dark color="light-blue" @click="saveAllergy">
            Adicionar
          </v-btn>
        </v-col>
      </v-row>

      <v-row v-if="lodash.isEmpty(allergies)" justify="center">
        <v-col cols="6">
          <v-alert color="orange" outlined text type="info">
            Sem alergias
          </v-alert>
        </v-col>
      </v-row>

      <v-row v-else>
        <v-col v-for="allergy in allergies" :key="allergy.id" cols="12">
          <v-card>
            <v-container fluid>
              <v-row align="center">
                <v-col cols="3">
                  <v-row dense>
                    <v-col class="font-weight-bold"> Substância </v-col>
                  </v-row>

                  <v-row dense>
                    <v-col> {{ allergy.allergySubstance.name }} </v-col>
                  </v-row>
                </v-col>

                <v-col cols="3">
                  <v-row dense>
                    <v-col class="font-weight-bold"> Tipo de alergia </v-col>
                  </v-row>

                  <v-row dense v-if="allergy.allergyType">
                    <v-col> {{ allergy.allergyType.name }} </v-col>
                  </v-row>
                </v-col>

                <v-col cols="4">
                  <v-row dense>
                    <v-col class="font-weight-bold"> Descrição </v-col>
                  </v-row>

                  <v-row dense>
                    <v-col> {{ allergy.description }} </v-col>
                  </v-row>
                </v-col>

                <v-spacer />

                <v-col cols="auto">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        icon
                        :attrs="attrs"
                        v-on="on"
                        @click="deleteAllergy(allergy.id)"
                        v-if="allowDelete"
                      >
                        <v-icon>eva-trash-outline</v-icon>
                      </v-btn>
                    </template>

                    <span> Excluir </span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import GET_ALLERGY_SUBSTANCES from "@/graphql/allergy_substances.gql";
import GET_ALLERGY_TYPES from "@/graphql/allergy_types.gql";
import GET_ALLERGIES from "@/graphql/allergies.gql";
import SAVE_ALLERGY from "@/graphql/save_allergy.gql";
import DELETE_ALLERGY from "@/graphql/delete_allergy.gql";

export default {
  name: "Allergy",
  props: {
    attendance: Object,
    showForm: {
      type: Boolean,
      default: true,
    },
    allowDelete: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      allergyTypes: [],
      allergyType: null,
      allergySubstances: [],
      allergySubstance: null,
      allergySubstanceError: "",
      description: "",
      allergies: [],
    };
  },
  computed: {
    orderedAllergies() {
      return this.lodash.orderBy(
        this.allergySubstances,
        [
          (e) =>
            e.name
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, ""),
        ],
        ["asc"]
      );
    },
  },
  apollo: {
    allergySubstances: {
      query: GET_ALLERGY_SUBSTANCES,
    },
    allergyTypes: {
      query: GET_ALLERGY_TYPES,
    },
    allergies: {
      query: GET_ALLERGIES,
      variables() {
        return {
          attendanceId: this.attendance.id,
        };
      },
      pollInterval: 20000,
    },
  },
  methods: {
    validate() {
      this.allergySubstanceError = "";

      if (this.allergySubstance) {
        return true;
      }

      this.allergySubstanceError = "Esse campo deve ser preenchido.";
      return false;
    },
    saveAllergy() {
      if (!this.validate()) return;

      this.apolloMutate({
        mutation: SAVE_ALLERGY,
        variables: {
          attendanceId: this.attendance.id,
          allergySubstanceId: this.allergySubstance.id,
          allergyTypeId: this.allergyType?.id,
          description: this.description,
        },
      }).then(() => {
        this.allergySubstance = null;
        this.allergyType = null;
        this.description = "";

        this.$apollo.queries.allergies.refetch();
      });
    },
    deleteAllergy(allergyId) {
      this.apolloMutate({
        mutation: DELETE_ALLERGY,
        variables: {
          allergyId: allergyId,
        },
      }).then(() => {
        this.$apollo.queries.allergies.refetch();
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
